import {
  PainDetailsData,
  PainDetailsForm,
  PainQuestion,
  translations,
} from '@dentalux/ui-library-core/custom/components/pain-details-form'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from 'src/react/components/Button/Button'
import Footer from 'src/react/components/Footer'
import Header from 'src/react/components/Header'
import Page from 'src/react/components/Page'
import useStyles from './styles'
import { Box } from '@mui/material'
import clsx from 'clsx'
import { ErrorBoundary } from '@components/ErrorBoundary/ErrorBoundary'
import { ErrorMessage } from '@components/ErrorMessage/ErrorMessage'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  questions: PainQuestion[]
  answers: PainDetailsData
  onChange: (key: string, value: string | undefined) => void
  onBackClick: () => void
  onContinue: () => void
}

export const PainDetailsScreen = ({ questions, answers, onChange, onBackClick, onContinue }: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <Page
      header={
        <Header
          desktopHeadingText={t(translations.titleText)}
          mobileHeadingText={t(translations.titleText)}
          onBackClick={onBackClick}
        />
      }
      body={
        <Box className={clsx(classes.body, 'notranslate')}>
          <ErrorBoundary
            additionalDebugData="Pain details form content clicked"
            fallback={<ErrorMessage message={t('api_errors.unexpected')} />}
          >
            <PainDetailsForm
              showTitle={false}
              hintText={t(translations.hintText)}
              questions={questions}
              data={answers}
              handleChange={onChange}
            />
          </ErrorBoundary>
        </Box>
      }
      footer={
        <Footer
          button={
            <Button
              fullSize
              type="button"
              data-test={TEST_IDS.nextButton}
              text={t(translations.buttonText)}
              onClick={onContinue}
            />
          }
        />
      }
    />
  )
}
